import { Settings } from 'superlikers-dynamic-forms'

import { PasswordEyeClosed, PasswordEyeOpen } from '@shared/ui'

/**
 * Apariencia de los formularios dinámicos, tomada de design/pernod1.svg:
 * etiqueta en `blue/frost` bold 12, control de 48px con filo `blue/navy` que
 * pasa a dorado al foco y a rojo en error, y mensaje de error de 11px.
 */
export const settings: Settings = {
  // `relative` para que el ojo de las contraseñas se ancle al campo y no a la página.
  wrapperClasses: 'relative flex flex-col gap-2',
  labelClasses: 'text-label text-blue-frost leading-none font-bold uppercase',
  errorClasses: 'text-action-red flex items-center gap-1.5 text-[11px] leading-none font-medium',
  helpTextClasses: 'text-caption text-blue-sky leading-none font-medium',

  inputClasses: 'field-control',
  validationFeedbackClasses: 'text-action-red text-[11px] font-medium',

  passwordEyeOpenIcon: PasswordEyeOpen,
  passwordEyeCloseIcon: PasswordEyeClosed,
  // 48px = etiqueta (16) + hueco (8) + media altura del control (24).
  passwordIconClasses: 'text-blue-sky absolute top-12 right-4 -translate-y-1/2',

  selectClasses: 'field-control field-select',
  selectOptionClasses: 'bg-app text-white',

  checkboxWrapperClasses: 'flex items-center gap-3',
  checkboxInputClasses: 'field-box rounded-md',
  checkboxLabelTextClasses: 'text-label text-blue-frost font-medium',

  checkboxGroupContainerClasses: 'flex flex-col gap-3',
  checkboxGroupItemWrapperClasses: 'flex items-center gap-3',
  checkboxGroupItemInputClasses: 'field-box rounded-md',
  checkboxGroupItemLabelClasses: 'text-label text-blue-frost font-medium',

  radioGroupContainerClasses: 'flex flex-col gap-3',
  radioItemWrapperClasses: 'flex items-center gap-3',
  radioItemInputClasses: 'field-box field-radio rounded-full',
  radioItemLabelClasses: 'text-label text-blue-frost font-medium',

  groupContainerClasses: 'flex flex-col gap-4',
  groupLegendClasses: 'text-body text-gold-cream font-bold',

  legendClasses: 'text-body text-gold-cream font-bold',
  arrayItemFieldsetClasses: 'flex flex-col gap-4',
  arrayItemContainerClasses: 'flex flex-col gap-4',
  arrayControlAddButtonClasses: 'btn-secondary btn-sm inline-flex items-center justify-center gap-2 rounded-full font-bold',
  arrayControlRemoveButtonClasses: 'btn-secondary-text text-label inline-flex items-center gap-1 font-bold',

  multiselectDropdownClasses: 'card-panel mt-1 flex flex-col overflow-hidden rounded-xl',
  multiselectDropdownItemClasses: 'text-label px-4 py-2.5 text-left text-white',
  multiselectDropdownItemHoverClasses: 'bg-blue-navy',
  multiselectDropdownItemSelectedClasses: 'bg-grad-peach-gold text-blue-night font-bold',
  multiselectDropdownItemDisabledClasses: 'cursor-not-allowed opacity-50',
  multiSelectDisplayedOptionsClasses: 'flex flex-wrap gap-2',
  multiSelectDisplayedOptionClasses: 'bg-grad-peach-gold text-blue-night text-caption flex h-7 items-center gap-1 rounded-full px-3 font-bold',
  multiSelectControlRemoveButtonClasses: 'text-blue-night',

  chipslistContainerClasses: 'flex flex-wrap gap-2',
  chipslistChipClasses: 'bg-grad-peach-gold text-blue-night text-caption flex h-7 items-center gap-1 rounded-full px-3 font-bold',
  chipslistInputClasses: 'field-control',
  chipslistAddWrapperClasses: 'flex items-center gap-2',
  chipslistAddButtonClasses: 'btn-secondary btn-sm inline-flex items-center justify-center gap-2 rounded-full font-bold',
  chipslistRemoveButtonClasses: 'text-blue-night',

  autocompleteInputClasses: 'field-control',
  autocompleteDropdownClasses: 'card-panel mt-1 flex flex-col overflow-hidden rounded-xl',
  autocompleteDropdownItemClasses: 'text-label px-4 py-2.5 text-left text-white',
  autocompleteDropdownItemHoverClasses: 'bg-blue-navy',
  autocompleteDropdownItemSelectedClasses: 'bg-grad-peach-gold text-blue-night font-bold',
  autocompleteLoadingTextClasses: 'text-caption text-blue-sky px-4 py-2.5'
}
